import { style } from '@angular/animations';
import { Injectable } from '@angular/core';
import { ToastController } from '@ionic/angular';

@Injectable({
  providedIn: 'root',
})
export class ToastService {
  constructor(private toastCtrl: ToastController) {}
  /*
  setTimeout(async () => {
        if(response.data.message){
          this.toastService.presentToast("confirm", response.data.message, 5000, "top", true);
        }
      }, 1000);
  */

  private buildToastOptions(type: string, msg: string, time: number, position, enableLargeVersion: boolean = false) {
    let toastIcon = '';
    let cssCustomClass = enableLargeVersion ? 'app-toast large-version ' : 'app-toast ';

    switch (type) {
      case 'confirm':
        cssCustomClass += 'app-confirm-toast';
        toastIcon = 'checkmark-circle';
        break;
      case 'warning':
        cssCustomClass += 'app-warning-toast';
        toastIcon = 'warning';
        break;
      case 'calendar':
        cssCustomClass += 'app-warning-toast';
        toastIcon = 'calendar-outline';
        break;
      case 'error':
        cssCustomClass += 'app-error-toast';
        toastIcon = 'alert-circle';
        break;
      case 'informative':
        cssCustomClass += 'app-informative-toast';
        toastIcon = 'information-circle';
        break;
    }

    return {
      icon: toastIcon,
      message: `${msg}`,
      duration: time,
      position: position as 'top' | 'bottom' | 'middle',
      cssClass: cssCustomClass,
      buttons: [{ side: 'end' as const, icon: 'close', role: 'cancel' }],
    };
  }

  async presentToast(type: string, msg: string, time: number, position, enableLargeVersion: boolean = false) {
    const toast = await this.toastCtrl.create(this.buildToastOptions(type, msg, time, position, enableLargeVersion));
    await toast.present();
    const shadowImg = toast.shadowRoot?.querySelector('.coin-icon-scorm') as HTMLElement;
if (shadowImg) {
  shadowImg.style.width = '20px';
  shadowImg.style.height = '20px';
  shadowImg.style.objectFit = 'contain';
}
  }

  async presentDismissableToast(type: string, msg: string, time: number, position, enableLargeVersion: boolean = false): Promise<() => Promise<boolean>> {
    const toast = await this.toastCtrl.create(this.buildToastOptions(type, msg, time, position, enableLargeVersion));
    await toast.present();
    return () => toast.dismiss();
  }


}
